import { createAction } from "@reduxjs/toolkit";

export const subscribeToStats = createAction("subscribeToStats");
export const unsubscribeFromStats = createAction("unsubscribeFromStats");
